import React from 'react';
import { roundToDecimals, findImage, readSessionValue } from './helper.js';
import { Images } from './consts.js';
import {Link} from 'react-router-dom';

export function BestProductsCard(props) {
  const isCheapest = props.cheapest;
  const isLoading = props.loadingData;
  let cheapestExtraHTML,
      priceInfo,
      totalPriceInfo,
      savingInfo,
      orderButton;

  if (isLoading) {
        priceInfo = (<span className="price-per-liter"><div className="loader-container"><div className="loader-small"></div><div className="price-per-liter-currency">€<br />/l</div></div></span>);
        totalPriceInfo = (<span className="suggested-card-totals-price"><div className="loader-container"><div className="loader-small"></div> €</div></span>);

  } else {
        priceInfo = (<span className="price-per-liter">{roundToDecimals(props.price,4)}
          <div className="price-per-liter-currency">€<br />/l</div></span>);
        totalPriceInfo = (<span className="suggested-card-totals-price">{roundToDecimals((props.price)
           * props.liters,2)} €</span>);
  }

  if (isCheapest) {
    cheapestExtraHTML = (
      <div className="cheapest-ribbon-container">
      <span className="cheapest-ribbon-span">Edullisin</span>
      <img src={Images[findImage(props.imageNames, props.providerName)]} className="product-logo" alt="" />
      </div>
    )
    if (isLoading) {
      orderButton = <div className="order inactive-btn">Tilaa</div>
    } else {
    orderButton = (<Link to={{pathname:"/order", state: {typeUse: props.typeUse, businessCustomer: props.businessCustomer,
      liters: props.liters,
      postcode: props.postcode, price: props.price, combinationId: props.combId,
      providerName: props.providerName}}}><div id="cheapest-order-button" className="order">Tilaa</div></Link>);
    }
  } else {
    cheapestExtraHTML = <div><img src={Images[findImage(props.imageNames, props.providerName)]} className="product-logo" alt="" /></div>;
    if (isLoading) {
      orderButton = <div id="cheapest-order-button" className="order inactive-btn">Tilaa</div>
    } else {
    orderButton = (<Link to={{pathname:"/order", state: {typeUse: props.typeUse, businessCustomer: props.businessCustomer,
      liters: props.liters,
       postcode: props.postcode, price: props.price, combinationId: props.combId,
       providerName: props.providerName}}}><div className="order">Tilaa</div></Link>);
     }
  }

  return (<div id={props.id} className="suggested-product">

    {cheapestExtraHTML}
    {priceInfo}
    <div className="suggested-card-totals">
    <span>Yhteensä</span>
    {totalPriceInfo}
    <span>{props.liters} l </span>
    </div>
    {orderButton}
    <div className="suggested-card-lower">
    <h6>{props.providerName}</h6>
    <ul>

     {props.productInfo}
    </ul>
    </div>
  </div>)
}

export function AllProductsCard(props) {
  const isLoading = props.loadingData;
  let   priceInfo,
        totalPriceInfo,
        submitBtn;
  if (isLoading) {
    priceInfo = (<span className="all-products-card-price"><div className="loader"></div>
    <span className="all-products-card-small-text"> / litraa</span></span>);
    totalPriceInfo = (<span className="all-products-card-total-price"><div className="loader"></div>
    <span className="all-products-card-small-text"> / {props.liters} l</span></span>);
    submitBtn = <div className="all-products-card-order-button inactive-btn"><span>Tilaa</span></div>
  } else {
    priceInfo = (<span className="all-products-card-price">{roundToDecimals(props.price,4)} €
    <span className="all-products-card-small-text"> / litraa</span></span>);
    totalPriceInfo = (<span className="all-products-card-total-price">{roundToDecimals((props.price)
      * props.liters,2)} €<span className="all-products-card-small-text"> / {props.liters} l</span></span>);
    submitBtn = <Link to={{pathname:"/order", state: {typeUse: props.typeUse, businessCustomer: props.businessCustomer,
      liters: props.liters, postcode: props.postcode,
      price: props.price, combinationId: props.combId,
      providerName: props.providerName}}}><div className="all-products-card-order-button"><span>Tilaa</span></div></Link>
   }
  return (
    <div className="row" key={props.id}>
    <div className="col-sm-12 col-md-12 col-lg-12">
    <div className="all-products-card">
    <div className="all-products-logo-container">
      <img className="all-products-card-product-logo" src={Images[findImage(props.imageNames, props.providerName)]} alt="" />
</div>
    <div className="all-products-card-extra-info">
    <div>
    <h6>{props.providerName}</h6>
    <ul>
      {props.productInfos}
    </ul>
    </div>
    </div>

    <div className="all-products-card-prices-container">
    {priceInfo}
    {totalPriceInfo}
    </div>
    {submitBtn}
    </div>
    </div>
    </div>
  )

}

export function PremiumProductCard(props) {
  const isLoading = props.loadingData;
  let   priceInfo,
        totalPriceInfo,
        submitBtn;
  if (isLoading) {
    priceInfo = (<span className="premium-products-card-price"><div className="loader"></div>
    <span className="premium-products-card-small-text"> / litraa</span></span>);
    totalPriceInfo = (<span className="premium-products-card-total-price"><div className="loader"></div>
    <span className="premium-products-card-small-text"> / {props.liters} l</span></span>);
    submitBtn = <div className="premium-products-card-order-button inactive-btn"><span>Tilaa</span></div>
  } else {
    priceInfo = (<span className="premium-products-card-price">{roundToDecimals(props.price,4)} €
    <span className="premium-products-card-small-text"> / litraa</span></span>);
    totalPriceInfo = (<span className="premium-products-card-total-price">{roundToDecimals((props.price)
      * props.liters,2)} €<span className="premium-products-card-small-text"> / {props.liters} l</span></span>);
      submitBtn = <Link to={{pathname:"/order", state: {typeUse: props.typeUse, businessCustomer: props.businessCustomer,
        liters: props.liters, postcode: props.postcode,
        price: props.price, combinationId: props.combId,
        providerName: props.providerName}}}><div className="premium-products-card-order-button"><span>Tilaa</span></div></Link>
   }
  return (
    <div className="row" key={props.id}>
    <div className="col-sm-12 col-md-12 col-lg-12">
    <div className="premium-products-card">
    <div className="premium-ribbon-container">
    <div className="premium-ribbon">Premium</div>

          <img className="premium-products-card-product-logo" src={Images[findImage(props.imageNames, props.providerName)]} alt="" />

    </div>
    <div className="premium-products-card-extra-info">
    <div>
    <h6>{props.providerName}</h6>
    <ul>
      {props.productInfos}
    </ul>
    </div>
    </div>

    <div className="premium-products-card-prices-container">
    {priceInfo}
    {totalPriceInfo}
    </div>
    {submitBtn}

    </div>
    </div>
    </div>
  )
}

export function OrderInformation(props) {
  return (
    <React.Fragment>
    <h3>Tilauksen tiedot</h3>
    <Link to={props.linkTo}>{props.linkText}</Link>
    <table>
    <tbody>
      <tr>
        <td>Tuote</td>
        <td>{props.providerName}</td>
      </tr>
      <tr>
        <td>Käyttötarkoitus</td>
        <td>{props.typeUse}</td>
      </tr>
      <tr>
       <td>Määrä</td>
       <td>{props.amount} l</td>
      </tr>
      <tr>
        <td>Toimitusalue</td>
        <td data-hj-suppress>{props.postcode} {props.city}</td>
      </tr>
      <tr>
        <td>Veroton hinta</td>
        <td>{props.noVatPrice.replace('.',',')} €</td>
      </tr>
      <tr>
        <td>Alv osuus (24%)</td>
        <td>{props.vatAmount.replace('.',',')} €</td>
      </tr>
      <tr>
        <td>Hinta yhteensä</td>
        <td className="green-text">{props.price.replace('.',',')} €</td>
      </tr>
      </tbody>
    </table>
    </React.Fragment>
  )
}


export function SubNav(props) {

  let links = [(<div key="sub-nav-step-1" className="sub-nav-item col-sm-4 col-md-4 col-lg-4"><Link to="/">
                      <div className="step-ball">1</div>
                      <div className="step-name">Valitse määrä</div>
                  </Link></div>)];

  if (props.currPage == 'order') {
    links.push(

      <React.Fragment key="sub-nav-second-half">
        <div key="sub-nav-step-2" className="sub-nav-active-page sub-nav-item col-sm-4 col-md-4 col-lg-4">
          <div className="step-ball">2</div>
          <div className="step-name">Omat tiedot</div>
        </div>


        <div key="sub-nav-step-3" className="sub-nav-item col-sm-4 col-md-4 col-lg-4">
          <div className="step-ball">3</div>
          <div className="step-name">Vahvistus</div>
        </div>

      </React.Fragment>
    )
  } else if (props.currPage == 'confirmOrder') {
    links.push(
      <React.Fragment key="sub-nav-second-half">
      <div key="sub-nav-step-2" className="sub-nav-item col-sm-4 col-md-4 col-lg-4">
      <Link to={{pathname:"/order",
       state:props.state }}>
          <div className="step-ball">2</div>
          <div className="step-name">Omat tiedot</div>
      </Link>
      </div>

      <div key="sub-nav-step-3" className="sub-nav-active-page sub-nav-item col-sm-4 col-md-4 col-lg-4">
        <div className="step-ball">3</div>
        <div className="step-name">Vahvistus</div>
      </div>

      </React.Fragment>
    )
  }
  return (
    <div className="row">

      {links}
    </div>
  )
}

export function OrderConfirmationCustomerInformation(props) {
  let companyName;
  if (props.companyName) {
    companyName = (
      <React.Fragment>
      <tr>
        <td>Yrityksen nimi</td>
        <td data-hj-suppress>{props.companyName}</td>
      </tr>
      </React.Fragment>
    );
  } else {
    companyName = (
      <React.Fragment>
      </React.Fragment>
    )
  }
  return (
    <React.Fragment>
    <table>
    <tbody>
      <tr>
        <td>Asiakasnumero</td>
        <td data-hj-suppress>{props.customerID}</td>
      </tr>
      {companyName}
      <tr>
        <td>Nimi</td>
        <td data-hj-suppress>{props.customerName}</td>
      </tr>
      <tr>
        <td>Katuosoite</td>
        <td data-hj-suppress>{props.streetAddress}</td>
      </tr>
      <tr>
        <td>Postinumero</td>
        <td data-hj-suppress>{props.postcode}</td>
      </tr>
      <tr>
        <td>Paikkakunta</td>
        <td data-hj-suppress>{props.city}</td>
      </tr>
      <tr>
        <td>Puhelin</td>
        <td data-hj-suppress>{props.phone}</td>
      </tr>
      <tr>
        <td>Sähköposti</td>
        <td data-hj-suppress>{props.email}</td>
      </tr>
      <tr>
        <td>Täyttö</td>
        <td>{props.tasanTayteen}</td>
      </tr>


      <tr>
        <td>Purkuohjeet</td>
        <td>{props.ohjeet}</td>
      </tr>
    </tbody>
    </table>
    <p data-hj-suppress>{props.purkuOhjeet}</p>
    </React.Fragment>
  )
}
